import { FC } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "@capacit-com/lara-law-shared-ui";
import AuthThemeToggle from "@/components/theme/AuthThemeToggle";
import { handleLogout } from "@/utils/auth";

const UnAuthorizedView: FC = () => {
  const { logout } = useAuth0();
  return (
    <div className="relative flex h-full flex-col items-center justify-center">
      <div className="absolute top-4 right-4 z-10">
        <AuthThemeToggle id="unauthorized-theme-toggle" />
      </div>
      <h1 className="mt-4 text-3xl font-bold tracking-tight sm:text-5xl">
        403 - Unauthorized
      </h1>
      <p className="mt-6 text-base leading-7">
        Du har ikke adgang til denne side.
      </p>
      <div className="flex gap-10 mt-4 w-fit">
        <Button onClick={() => handleLogout(logout)}>Logout</Button>
      </div>
    </div>
  );
};

export default UnAuthorizedView;
